import { useSyncExternalStore } from 'react';

import {
  getThemeSnapshot,
  setThemeMode,
  subscribeTheme,
  type ResolvedTheme,
  type ThemeMode,
} from '../lib/theme';

type ThemeValue = {
  /** Skutočne použitý režim (pri „Systém“ podľa zariadenia). */
  theme: ResolvedTheme;
  /** Voľba človeka vrátane „Systém“. */
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  /** Rýchle prepnutie z menu profilu: vždy na opačný, ako je práve vidieť. */
  toggleTheme: () => void;
};

/**
 * Režim je malý obchod mimo Reactu (lib/theme.ts), nie kontext: musí sa
 * zapísať na <html> ešte pred prvým vykreslením a nastavenia, menu profilu aj
 * spodná lišta ho menia z rôznych miest stromu.
 */
export const useTheme = (): ThemeValue => {
  const { mode, theme } = useSyncExternalStore(subscribeTheme, getThemeSnapshot, getThemeSnapshot);
  return {
    theme,
    mode,
    setMode: (next) => setThemeMode(next),
    toggleTheme: () => setThemeMode(theme === 'dark' ? 'light' : 'dark'),
  };
};
